const useStyles = () => {
    let blueTextSx = (theme) => {
        return { color: theme.palette.primary.main };
    };

    let boldTextSx = (theme) => {
        return {
            fontWeight: 500,
        };
    };

    let instructionTextSx = (theme) => {
        return {
            '&#instructions': {
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-around',
                mb: theme.spacing(3),
            },
        };
    };

    let deleteButtonSx = (theme) => {
        return {
            '&#delete-button': {
                backgroundColor: theme.palette.error.main,
                '&:disabled': {
                    color: '#fff',
                    filter: 'saturate(50%)',
                },
            },
        };
    };

    return {
        blueTextSx,
        boldTextSx,
        instructionTextSx,
        deleteButtonSx,
    };
};

export default useStyles;